import { render, staticRenderFns } from "./CPMDashboardTable.vue?vue&type=template&id=033b26d2&scoped=true&"
import script from "./CPMDashboardTable.vue?vue&type=script&lang=js&"
export * from "./CPMDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./CPMDashboardTable.vue?vue&type=style&index=0&id=033b26d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b26d2",
  null
  
)

export default component.exports